import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormHeader from "../../../../components/FormHeader";
import FormLease from "../../../../components/FormLease";

function LeaseForm() {
  return (
    <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
      <FormHeader title="Lease Settings" description="" />
      <Grid container spacing={1}>
        <FormLease suffix="lease" />
      </Grid>
    </Paper>
  );
}

export default LeaseForm;
